angular
    .module('app')
    .component('log', {
        templateUrl: '/templates/pages/log/log.html',
        controller: 'LogController',
        controllerAs: 'vm',
    });